




































































import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import { eventBus, actionsEvent } from '@/setup';
import HandleErrors from '../../config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { fetchMID } from './fetchMID';
import Confirmation from '@/components/Confirmation.vue';
import { AgGridVue } from 'ag-grid-vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { LoadingService } from '@/services/loadingService';
import DatePicker from '@/reusable/Form/DatePicker.vue';

@Component({
  components: {
    MantenedorGridSinCodigo,
    DatePicker,
    TimePicker,
    'app-confirmacion': Confirmation,
    'ag-grid-vue': AgGridVue,
  },
})
export default class LogEventosMID extends ComponenteBase {
  [x: string]: any;
  dialogConfirmacionClose: boolean = false;
  filtro: any = '';
  ordesList: any[] = [];
  dateString: any = new Date();
  dateStringEnd: any = new Date();
  funcionalidad: Funcionalidades = Funcionalidades.LogEventosMID;
  selectedItem: any;
  showTables = false;
  rules = {
    required: (value: any) => !!value || 'Required.',
    counter: (value: any) => value.length <= 15 || 'Maximo 15 caracteres',
    soloLetras: (value: any) => {
      return value.match(/^[a-zA-Z]*$/) || 'Solo se permiten letras';
    },
    soloNumeros: (value: any) => {
      return value.match(/^[0-9]*$/) || 'Solo se permiten letras';
    },
    email: (value: any) => {
      if (value != '') {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      }
    },
  };
  formFields: {
    dateStart: any;
    dateEnd: any;
    timeStart: any;
    timeEnd: any;
  } = {
    dateStart: {
      label: 'Fecha inicio',
      value: '',
      selectedValue: '',
    },
    dateEnd: {
      label: 'Fecha Fin',
      value: '',
      selectedValue: '',
    },
    timeStart: {
      label: 'Hora Inicio',
      selectedValue: '',
      value: moment('00:00', 'HHmm'),
    },
    timeEnd: {
      label: 'Hora fin',
      selectedValue: '',
      value: moment('23:59', 'HHmm'),
    },
  };

  async GetLogCaidas() {
    let self = this;
    this.loadingService.showLoading();
    this.tablaDatos = [];
    this.ordesList = [];
    const formattedFechaInicio = moment(this.formFields.dateStart.value).format(
      'YYYY-MM-DD'
    );
    const formattedFechaFin = moment(this.formFields.dateEnd.value).format(
      'YYYY-MM-DD'
    );
    const formattedHoraInicio =
      moment(this.formFields.timeStart.value.toString())
        .format('HH:mm')
        .toString() + ':00';
    const formattedHoraFin =
      moment(this.formFields.timeEnd.value.toString())
        .format('HH:mm')
        .toString() + ':59';
    return fetchMID(
      {
        fini: formattedFechaInicio,
        horaini: formattedHoraInicio,
        ffin: formattedFechaFin,
        horafin: formattedHoraFin,
      },
      'mid_cliente/GetLogCaidas'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.visible = true;
          return data.data.data;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        console.error('Error:', error);
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async clearFilters() {
    this.visible = false;
    this.filtro = undefined;
    this.ordesList = null;
    this.gridApi.setRowData([]);
    this.formFields.dateStart.value = moment(
      this.dateString.getFullYear() +
        '-' +
        (this.dateString.getMonth() + 1).toString() +
        '-' +
        this.dateString.getDate()
    );
    this.formFields.dateEnd.value = moment(
      this.dateStringEnd.getFullYear() +
        '-' +
        (this.dateStringEnd.getMonth() + 1).toString() +
        '-' +
        this.dateStringEnd.getDate()
    );
    this.formFields.timeStart.value = ''; // Reinicia con segundos
    this.formFields.timeEnd.value = ''; // Reinicia con segundos
    const horaFin = moment('23:59', 'HHmm');
    const horaIni = moment('00:00', 'HHmm');
    this.formFields.timeStart.value = moment(horaIni, 'HHmm');
    this.formFields.timeEnd.value = moment(horaFin, 'HHmm');
    this.showTable();
  }
  compras: any;
  delete: any;

  usuarioActivo: any = {};

  async showTable() {
    this.showTables = true;
    this.ordesList = (await this.GetLogCaidas()) || [];
    if (this.ordesList[0]['fecha_ingreso'] != undefined) {
      const transformedData = this.ordesList.map(item => ({
        fecha_ingreso: item.fecha_ingreso,
        fecha_act: item.fecha_act,
        path_integracion: item.path_integracion,
        log: item.log,
      }));
      this.gridApi.setRowData(transformedData);
      this.gridApi.setDomLayout('autoHeight');
    } else {
      this.gridApi.setRowData([]);
    }
  }
  async onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.gridApi.setRowData([]);
    this.gridApi.setDomLayout('autoHeight');
    this.showTable();
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  showModalNew = false;
  pasoActivoIndex = 1;
  pasoActivoEditar = 1;

  //Declarar todas las Acciones Mantenedores
  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  accionCrear: PermisoAccion = {
    accionCodigo: 2,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [this.accionConsultar, this.accionCrear];

  // Globales
  tabModel: string = 'tab-3';
  dialog: Boolean = false;
  search: string = '';

  gridOptions: GridOptions;

  loadingService = new LoadingService();
  intervalo: any; //Intervalo para el buscador
  chequearPermisosBtnCrear: boolean = true;
  editedIndex: number = -1;

  handleErrors: HandleErrors = new HandleErrors();

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  serverSide: any;

  // Interfaces
  editedItem: IFuncionalidad = {};
  funcionalidades: Array<IFuncionalidad> = [];

  //vuex
  usuarioId: number = store.state.userId;

  // Componentes
  //showModalNew: boolean = false;
  showModalEdit: boolean = false;
  modalEsEdicion: boolean = false;
  showModalAsignar: boolean = false;

  constructor() {
    super();

    this.columnDefs = [
      {
        headerName: 'Fecha Ingreso',
        field: 'fecha_ingreso',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Fecha Actualización',
        field: 'fecha_act',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Path Integración',
        field: 'path_integracion',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Log',
        field: 'log',
        sortable: true,
        resizable: true,
        minWidth: 100,
        lockPinned: true,
      },
    ];

    this.gridOptions = {
      rowSelection: 'single',
      pagination: true,
      paginationPageSize: 6, //Solución Paginación
      cacheBlockSize: 6, //Solución Paginación //Ordenamiento + Seleccion
      paginationAutoPageSize: false,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      serverSideDatasource: this.serverSide,
      columnTypes: {
        fecha: {
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.onGridReady,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
    };
  }

  mounted() {
    eventBus.changeTitlePage('Módulos');
    this.formFields.dateStart.value = moment(
      this.dateString.getFullYear() +
        '-' +
        (this.dateString.getMonth() + 1).toString() +
        '-' +
        this.dateString.getDate()
    );
    this.formFields.dateEnd.value = moment(
      this.dateStringEnd.getFullYear() +
        '-' +
        (this.dateStringEnd.getMonth() + 1).toString() +
        '-' +
        this.dateStringEnd.getDate()
    );

    this.showTable();
  }

  created() {
    this.initialize();
  }

  onFilterTextBoxChanged() {
    clearInterval(this.intervalo);
    const self = this;
    this.intervalo = setInterval(function() {
      if (self.search.length >= 2) {
        self.gridApi.onFilterChanged();
      } else if (self.search.length === 0) {
        self.gridApi.setServerSideDatasource(self.serverSide);
      }
      clearInterval(self.intervalo);
    }, 500);
  }
  rutSelected: string = '';
  initialize() {
    actionsEvent.$on('actionsEvent', (data: any) => {
      if (this.funcionalidad === Funcionalidades.LogEventosMID) {
        if (data.action === Accion.Editar) {
          this.editedItem = null;
          // Editar - Ver Detalle
          this.modalEsEdicion = data.action == Accion.Editar;
          this.editedIndex = data.id;
          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.id == rowNode.data.id) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            this.showModalEdit = true;
            this.editedItem = data.cellRendererParams.data.proveedorrut;
          }
        }
      }
    });
  }

  beforeDestroy() {}
}
